module.exports = __webpack_public_path__ + "static/p-13-bd7cce234b337e251e5606334f163406.jpg";